// src/components/AddExpenseModal.tsx
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';
import styles from './BusinessExpensesTable.module.css';

interface AddBalanceSheetItemsProps {
  open: boolean;
  onSubmit: (name: string) => void;
  onClose: () => void;
}

const AddBalanceSheetItems: React.FC<AddBalanceSheetItemsProps> = ({ open, onSubmit, onClose }) => {
  const [name, setName] = useState('');

  const handleSubmit = () => {
    if (name.trim()) {
      onSubmit(name);
      setName('');
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add New Expense</DialogTitle>
      <DialogContent>
        <TextField
          label="Expense Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={styles.descriptionInput}
          fullWidth
          autoFocus
          margin="dense"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!name.trim()}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddBalanceSheetItems;